import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatDate } from "../lib/api";
import Layout, { Card, Label, Badge, Spinner } from "../components/Layout";

export default function Decisions() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/bid-decisions");
      setItems(data);
      setLoading(false);
    })();
  }, []);

  return (
    <Layout title="Decisioni Bid / No-Bid" subtitle="Workflow strutturato di valutazione strategica delle gare">
      {loading ? <Spinner /> :
      items.length === 0 ? (
        <Card><div className="text-sm text-zinc-500 py-8 text-center">Nessuna decisione registrata. Apri una gara e crea una valutazione.</div></Card>
      ) : (
        <Card className="p-0 overflow-hidden">
          <table className="w-full text-sm" data-testid="decisions-table">
            <thead className="bg-zinc-50 border-b border-zinc-200">
              <tr>
                <Th>Gara</Th><Th>Stato</Th><Th>Voti</Th><Th>Esito</Th><Th>Data</Th><Th></Th>
              </tr>
            </thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.id} className="border-b border-zinc-100 hover:bg-zinc-50 cursor-pointer" onClick={() => nav(`/tenders/${d.tender_id}`)} data-testid={`decision-${d.id}`}>
                  <td className="px-4 py-3 font-mono text-xs">{d.tender_id.slice(0, 8)}</td>
                  <td className="px-4 py-3"><Badge>{d.state}</Badge></td>
                  <td className="px-4 py-3 font-mono text-xs">{d.votes.length}</td>
                  <td className="px-4 py-3">
                    {d.final_outcome ? <Badge kind={d.final_outcome === "BID" ? "aperta" : "compromessa"}>{d.final_outcome}</Badge> : "—"}
                  </td>
                  <td className="px-4 py-3 text-xs">{formatDate(d.created_at)}</td>
                  <td className="px-4 py-3 text-zinc-400">→</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </Layout>
  );
}

function Th({ children }) {
  return <th className="px-4 py-3 text-left label-up text-zinc-600">{children}</th>;
}
